module.exports = __webpack_public_path__ + "img/Gabriel Martinelli.692246d9.png";